<template>
	<div id="fileuploads">

		<el-form ref="fileuploadForm" label-position="top" :model="file" @submit.native.prevent >
			<el-form-item label="File Name" prop="FileName"
						:rules="[{ required: true, message: 'File Name is required', trigger: 'blur'}]"
			>
				<el-input v-model="file.FileName">
				</el-input>
			</el-form-item>
			<el-form-item label="Client File Name" prop="ClientFileName"
						:rules="[{ required: true, message: 'Client File Name is required', trigger: 'blur'}]"
			>
				<el-input v-model="file.ClientFileName">
				</el-input>
			</el-form-item>
			<el-form-item label="File Type" prop="FileType"
						:rules="[{ required: true, message: 'File Type is required', trigger: 'blur'}]"
			>
				<el-radio-group v-model="file.FileType" size="default">
					<el-radio-button value="audio">Audio</el-radio-button>
					<el-radio-button selected value="text">Text (pdf/zip)</el-radio-button>
				</el-radio-group>
			</el-form-item>
		</el-form>

		<template v-if="file.FileType == 'audio'" >
			<div class="fu-field-block">
				<div class="fu-field-label">Sample Audio</div>
				<form class="fu-upload-form" novalidate method="post" enctype="multipart/form-data">
					<div class="fu-dropzone-row">
						<div id="SampleAudio" v-bind:class="{ 'success_upload' : isSuccess, 'failed_upload' : isFailed }" class="SampleURL fu-dropzone" :style="uploadImage">
							<div class="fu-upload-icon" aria-hidden="true"><i class="fa-light fa-cloud-arrow-up"></i></div>
							<div class="fu-uploading-overlay" v-if="isSaving && whichFile == 'SampleURL'"><i class="fa-light fa-spinner-third fa-spin fa-lg"></i></div>
							<input type="file" id="SampleURLInput" name="SampleURL" :disabled="isSaving" @change="uploadFile($event.target.name)" accept="audio/*" class="input-file">
							<div v-if="RemoveAudio('SampleURL')" class="fu-remove sample" @click.prevent="removeaudio('SampleURL')"><i class="fa-light fa-circle-xmark"></i></div>
						</div>
						<span v-if="file.SampleURL" class="fu-file-meta">
							<i v-if="SampleURLPlaying == 'n'" class="fa-light fa-circle-play fu-play-icon" @click="playSound(file.SampleURL, 'FullURL');SampleURLPlaying = 'y';"></i>
							<i v-else class="fa-light fa-circle-pause fu-play-icon" @click="stopSound(file.SampleURL);SampleURLPlaying = 'n';"></i>
							<span class="fu-filename">{{ file.SampleURL}}</span>
						</span>
					</div>
				</form>
			</div>
			<div class="fu-field-block">
				<div class="fu-field-label">Full Audio</div>
				<form class="fu-upload-form" novalidate method="post" enctype="multipart/form-data">
					<div class="fu-dropzone-row">
						<div id="FullAudio" v-bind:class="{ 'success_upload' : isSuccess, 'failed_upload' : isFailed }" class="FullURL fu-dropzone" :style="uploadImage">
							<div class="fu-upload-icon" aria-hidden="true"><i class="fa-light fa-cloud-arrow-up"></i></div>
							<div class="fu-uploading-overlay" v-if="isSaving && whichFile == 'FullURL'"><i class="fa-light fa-spinner-third fa-spin fa-lg"></i></div>
							<input type="file" id="FullURLInput" name="FullURL" :disabled="isSaving" @change="uploadFile($event.target.name)" accept="audio/*" class="input-file">
							<div v-if="RemoveAudio('FullURL')" class="fu-remove full" @click.prevent="removeaudio('FullURL')"><i class="fa-light fa-circle-xmark"></i></div>
						</div>
						<span v-if="file.FullURL" class="fu-file-meta">
							<i v-if="FullURLPlaying == 'n'" class="fa-light fa-circle-play fu-play-icon" @click="playSound(file.FullURL, 'SampleURL');FullURLPlaying = 'y';"></i>
							<i v-else class="fa-light fa-circle-pause fu-play-icon" @click="stopSound(file.FullURL);FullURLPlaying = 'n';"></i>
							<span class="fu-filename">{{ file.FullURL}}</span>
						</span>
					</div>
				</form>
			</div>
		</template>
		<template v-else>
			<div class="fu-field-block">
				<div class="fu-field-label">Text File (Doc, PDF, Zip, etc)</div>
				<form class="fu-upload-form" novalidate method="post" enctype="multipart/form-data">
					<div class="fu-dropzone-row">
						<div id="TextFile" v-bind:class="{ 'success_upload' : isSuccess, 'failed_upload' : isFailed }" class="FullURL fu-dropzone" :style="uploadDocImage">
							<div class="fu-upload-icon" aria-hidden="true"><i class="fa-light fa-cloud-arrow-up"></i></div>
							<div class="fu-uploading-overlay" v-if="isSaving && whichFile == 'FullURL'"><i class="fa-light fa-spinner-third fa-spin fa-lg"></i></div>
							<input type="file" id="FullURLInput" name="FullURL" :disabled="isSaving" @change="uploadFile($event.target.name)" accept="*" class="input-file">
							<div v-if="RemoveAudio('FullURL')" class="fu-remove full" @click.prevent="removeaudio('FullURL')"><i class="fa-light fa-circle-xmark"></i></div>
						</div>
						<span v-if="file.FullURL" class="fu-file-meta">
							<span class="fu-filename">{{ file.FullURL}}</span>
						</span>
					</div>
				</form>
			</div>
		</template>

		<div class="va-section-header fu-section-header">
			<div class="va-section-title"><i class="fa-light fa-sliders va-section-icon"></i> File Properties</div>
		</div>

		<div class="fu-field-block">
			<div class="fu-field-label">Status</div>
			<el-radio-group v-model="file.Archived" size="default">
				<el-radio-button value="n">Active</el-radio-button>
				<el-radio-button selected value="y">Archived</el-radio-button>
				<el-radio-button value="h">Historical</el-radio-button>
			</el-radio-group>
		</div>
		<div class="fu-field-block">
			<div class="fu-field-label">Date/Time File was Posted</div>
			<el-date-picker v-model="file.PostDate" size="default" default-first-option filterable
							type="datetime"
							format="YYYY-MM-DD hh:mm a"
							value-format="YYYY-MM-DD HH:mm:ss"
							placeholder="Post Date">
			</el-date-picker>
		</div>
		<template v-if="file.FileType == 'audio'" >
			<div class="fu-field-block">
				<div class="fu-field-label">Specifications</div>
				<div class="fu-specs-row">
					<el-select key="select1" size="small" class="fu-spec-select fu-spec-bpm" v-model="file.BPMID" placeholder="BPM" default-first-option filterable clearable>
						<el-option
								v-for="item in BPMs"
								:key="item.FileSpecificationID"
								:label="item.SpecName"
								:value="item.FileSpecificationID">
						</el-option>
					</el-select>
					<el-select key="select2" size="small" class="fu-spec-select fu-spec-genre" v-model="file.GenreID" placeholder="Genre" default-first-option filterable clearable>
						<el-option
								v-for="item in Genres"
								:key="item.FileSpecificationID"
								:label="item.SpecName"
								:value="item.FileSpecificationID">
						</el-option>
					</el-select>
					<el-select key="select3" size="small" class="fu-spec-select fu-spec-mood" v-model="file.MoodID" placeholder="Mood" default-first-option filterable clearable>
						<el-option
								v-for="item in Moods"
								:key="item.FileSpecificationID"
								:label="item.SpecName"
								:value="item.FileSpecificationID">
						</el-option>
					</el-select>
					<el-select key="select4" size="small" class="fu-spec-select fu-spec-format" v-model="file.FormatID" placeholder="Format" default-first-option filterable clearable>
						<el-option
								v-for="item in Formats"
								:key="item.FileSpecificationID"
								:label="item.SpecName"
								:value="item.FileSpecificationID">
						</el-option>
					</el-select>
					<el-select key="select5" size="small" class="fu-spec-select fu-spec-length" v-model="file.LengthID" placeholder="Length" default-first-option filterable clearable>
						<el-option
								v-for="item in Lengths"
								:key="item.FileSpecificationID"
								:label="item.SpecName"
								:value="item.FileSpecificationID">
						</el-option>
					</el-select>
				</div>
			</div>
			<div class="fu-field-block">
				<div class="fu-field-label">Duration (Seconds)</div>
				<el-input v-model="file.Duration" class="smallNumber" size="default">
				</el-input>
			</div>
		</template>
		<div class="fu-field-block">
			<div class="fu-field-label">Clients</div>
			<el-select key="select6" v-model="file.OrganizationIDs" class="oneHundred" placeholder="Select" multiple default-first-option filterable clearable>
				<el-option
						v-for="item in Organizations"
						:label="item.OrganizationName"
						:value="item.OrganizationID"
						:key="item.OrganizationID">
				</el-option>
			</el-select>
		</div>

		<div class="row" v-if="(fileData || modifyAccess || createAccess)" >
            <div class="col-12 text-center">
                <button class="btn btn-success btn-icon" @click="save" style="margin-right: 10px;">
                    <i class="fa-light fa-check"></i> <span> Save Changes</span>
                </button>
                <button class="btn btn-icon btn-dark cancel"  @click="reset(true)">
                    <i class="fa-light fa-times"></i>  <span>Cancel</span>
                </button>
            </div>
        </div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import axios from 'axios';
    import Util from '../assets/js/util.js';

	const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;
	export default {
		data () {
			return {
				currentStatus : 0,
				uploadReady : true,
				currentFile : '',
				whichFile : '',
				audio : '',
				SampleURLPlaying : 'n',
				FullURLPlaying : 'n',
				file :{FileID: 0, FileType: 'audio', FileName : '', ClientFileName : '', SampleURL : '', FullURL : '', OrganizationIDs : [], Archived : 'n'},
				Organizations : [],
				BPMs : [],
				Genres : [],
				Moods : [],
				Formats : [],
				Lengths: [],
 			}
		},
		name: 'FileUploads',
		props: {
			config : { type: Object },
			fileData : {
				type: [Object,Array],
				required: false,
				default: () => {}
			},
		},
		computed: {
			...mapGetters({ currentUser: 'currentUser' }),
			...mapGetters({ componentIDs: 'componentIDs' }),
			isInitial() {
				return this.currentStatus === STATUS_INITIAL;
			},
			isSaving() {
				return this.currentStatus === STATUS_SAVING;
			},
			isSuccess() {
				return this.currentStatus === STATUS_SUCCESS;
			},
			isFailed() {
				return this.currentStatus === STATUS_FAILED;
			},
	        createAccess () {
				if (this.fileData) {
					return true;
				} else {
			        return Util.createAccess(this.currentUser);
		        }
            },
	        modifyAccess () {
		        if (this.fileData) {
			        return true;
		        } else {
			        return Util.modifyAccess(this.currentUser);
		        }
            },
			defaultImage () {
				return require('../images/file_music-upload-512.png'); 
			},
			defaultDocImage () {
				return require('../images/file_doc-upload-200.png');
			},
			uploadImage() {
				let logo = 'backgroundImage: url(' + this.defaultImage + ')';
				return logo;
			},
			uploadDocImage() {
				let logo = 'backgroundImage: url(' + this.defaultDocImage + ')';
				return logo;
			},

		},
		methods: {
			RemoveAudio(whichOne) {
				if (this.file[whichOne]) {
					return true;
				} else {
					return false;
				}
			},
			playSound(file, whichOne) {
				if (this.currentFile) {
					this.stopSound(this.currentFile);
				}
				this[whichOne] = 'n';
				this.currentFile = file;
				this.audio = new Audio(file);
				var playPromise = this.audio.play();

				if (playPromise !== undefined) {
					playPromise.then(_ => {
					})
						.catch(error => {
							console.log(`playSound error: ${error}`);
						});
				}
			},
			stopSound(file, whichOne) {
				this.currentFile = '';
				this[whichOne] = 'n';
				var playPromise = this.audio.pause();

				if (playPromise !== undefined) {
					playPromise.then(_ => {
					})
						.catch(error => {
							console.log(`playSound error: ${error}`);
						});
				}
			},
			reset(showMessage) {
				// reset form to initial state
				if (this.fileData) {
					this.$emit('refreshData');
					this.$emit('close');
				}
				this.currentStatus = STATUS_INITIAL;
				this.getInitialData ();
				this.file = {};

				if (showMessage) {
					this.$notify({
						title: 'Success',
						message: 'Data has been reset',
						type: 'success',
						duration: 1500,
						showClose: false
					});
                 }
			},
			getInitialData () {
				var tables = ['BPMs','Genres','Moods','Lengths','Formats','Organizations'];
				axios.post('/index/tableData', {'tables': tables },
				)
					.then(response => {
						if (response.data.result == 'success') {
							for (let value of tables) {
								this[value] = response.data[value];
							}
						} else {
						}
					}).catch(response => {
				});
			},
			save () {
				this.$refs['fileuploadForm'].validate((valid) => {
					if (valid) {
						if (this.isValid()) {
							if (this.currentStatus == STATUS_SAVING) {
								return true;
							}
							this.currentStatus = STATUS_SAVING;

							axios.post('/files/save', {file: this.file}
							)
								.then(response => {
									if (response.data.result == 'success') {
										this.currentStatus = STATUS_INITIAL;

										this.$notify({
											title: 'Success',
											message: 'File has been saved',
											type: 'success',
											duration: 1500,
											showClose: false
										});
										this.file = {};
										if (this.fileData) {
											this.$emit('refreshData');
											this.$emit('close');
										}
									} else {
										this.currentStatus = STATUS_FAILED;
										this.displayPopup(response.data.message);
									}
								}).catch(response => {
								this.currentStatus = STATUS_FAILED;
							});
						} else {
							this.displayPopup('A File Name and Full Audio File are required.');
						}
					}
				});
			},
			isValid () {
				if (this.file.FileName == '' || this.file.FullURL == '') {
					return false;
				}
				return true;
			},
			uploadFile(fileName) {
				if (this.currentStatus == STATUS_SAVING) {
                    return true;
                }
				this.whichFile = fileName;
				// upload data to the server
				this.currentStatus = STATUS_SAVING;
				var fileSizeInMB = (document.querySelector('#' + fileName + 'Input').files[0].size / (1024 * 1024)).toFixed(2);
				axios.post('/index/uploadfile', document.querySelector('#' + fileName + 'Input').files,
					{ headers: { 'Content-Type': 'multipart/form-data'} }
				)
					.then(response => {
						if (response.data.result == 'success') {
							this.currentStatus = STATUS_SUCCESS;
							this.file[fileName] = response.data.url;
							this.file['Size'] = fileSizeInMB;
						} else {
							this.currentStatus = STATUS_FAILED;
							this.displayPopup (response.data.message);
						}
						document.getElementById(fileName + 'Input').value = "";
					}).catch(response => {
					this.currentStatus = STATUS_FAILED;
				});
			},
			removeaudio(whichOne) {
				this.file[whichOne] = '';
			},

	        displayPopup (message) {
				this.$alert(message,  {
					type: 'error',
					confirmButtonText: 'OK',
				});
	        }
		},
		mounted() {
		  //set post date to today
      var m = new Date();
      var dateString =
        m.getFullYear() + "/" +
        ("0" + (m.getMonth()+1)).slice(-2) + "/" +
        ("0" + m.getDate()).slice(-2) + " " +
        ("0" + m.getHours()).slice(-2) + ":" +
        ("0" + m.getMinutes()).slice(-2) + ":" +
        ("0" + m.getSeconds()).slice(-2);
      this.file.PostDate = dateString;
			if (this.fileData && this.fileData.FileID > 0) {
				this.file = this.fileData;
			}
			this.getInitialData();
		},
	}
</script>
<style scoped>

	.el-select {
		width: 100%;
		max-width: 300px;
	}
	.oneHundred.el-select {
		max-width: 100%;
	}

	/* ── Field blocks ─────────────────────────────────────── */
	.fu-field-block { margin-bottom: 22px; }
	.fu-field-label {
		font-size: 10.5px;
		font-weight: 600;
		text-transform: uppercase;
		letter-spacing: 0.08em;
		color: var(--el-text-color-secondary, #64748B);
		margin-bottom: 8px;
	}
	.fu-section-header { margin: 4px 0 18px; }

	/* ── Upload dropzones ─────────────────────────────────── */
	.fu-upload-form { margin: 0; }
	.fu-dropzone-row {
		display: flex;
		align-items: center;
		gap: 16px;
		flex-wrap: wrap;
	}
	.input-file {
		opacity: 0; /* invisible but it's there! */
		width: 100%;
		height: 100%;
		position: absolute;
		cursor: pointer;
		left:0;
		top:0;
	}
	.fu-dropzone {
		position: relative;
		width: 88px;
		height: 88px;
		background-color: #fff;
		background-position: center 38%;
		background-repeat: no-repeat;
		background-size: 52%;
		border: 1.5px dashed var(--el-border-color, #E2E8F0);
		border-radius: 10px;
		cursor: pointer;
		flex-shrink: 0;
		transition: border-color 0.15s;
	}
	.fu-dropzone:hover { border-color: var(--el-color-primary, #3F9CA8); }
	.fu-dropzone:hover .fu-upload-icon { transform: scale(1.1); }
	.fu-upload-icon {
		position: absolute;
		bottom: -6px;
		right: -6px;
		width: 24px;
		height: 24px;
		border-radius: 50%;
		background: var(--el-color-primary, #3F9CA8);
		color: #fff;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 12px;
		box-shadow: 0 1px 4px rgba(15,23,42,0.25);
		pointer-events: none;
		transition: transform 0.15s;
	}
	.success_upload {
		border: 2px solid var(--el-color-success, #16A34A) !important;
	}
	.failed_upload {
		border: 2px solid var(--el-color-danger, #EF4444) !important;
	}
	.fu-uploading-overlay {
		position: absolute;
		inset: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		background: rgba(255,255,255,0.8);
		border-radius: 8px;
		color: var(--el-color-primary, #3F9CA8);
	}
	.fu-remove {
		font-size: 13px;
		cursor: pointer;
		position: absolute;
		top: -8px;
		right: -8px;
		background: #fff;
		color: var(--el-text-color-secondary, #64748B);
		width: 20px;
		height: 20px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		box-shadow: 0 1px 4px rgba(15,23,42,0.2);
	}
	.fu-remove:hover { color: var(--el-color-danger, #EF4444); }
	.fu-file-meta {
		display: flex;
		align-items: center;
		gap: 8px;
		font-size: 12.5px;
		color: var(--el-text-color-secondary, #64748B);
	}
	.fu-play-icon {
		cursor: pointer;
		font-size: 20px;
		color: var(--el-color-primary, #3F9CA8);
		flex-shrink: 0;
	}
	.fu-filename {
		word-break: break-all;
	}

	/* ── Specifications row ──────────────────────────────────── */
	.fu-specs-row {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 10px;
	}
	#app .fu-spec-select  { width: 100%; max-width: unset; flex: 0 0 auto; }
	#app .fu-spec-bpm    { width: 120px; }
	#app .fu-spec-genre  { width: 180px; }
	#app .fu-spec-mood   { width: 180px; }
	#app .fu-spec-format { width: 120px; }
	#app .fu-spec-length { width: 150px; }

	#app .el-input.smallNumber {
		width: 75px;
	}
</style>
